import {createFeatureSelector, createSelector} from "@ngrx/store";
import {planetResourceFeatureKey} from "./planet-resource.reducer";
import {PlanetResource} from "../../models/PlanetResource";

export const planetResourceSelector = createFeatureSelector<PlanetResource[]>(planetResourceFeatureKey);
